import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { productAccessorVariantHasMultipleOffers } from './productAccessorVariantHasMultipleOffers'

export const productAccessorGetUniqueVariantSellersCount = (
  variant: PimProductV11,
): number => {
  if (!variant.offers || !productAccessorVariantHasMultipleOffers(variant)) {
    return 0
  }

  /**
   * Edgecase: could happen that there are offers from same seller.
   * Putting all the sellers in a set to create a unique sellers array
   * and then returning the size of the set to get the number of the unique sellers
   */
  const uniqueSellers = new Set(
    variant.offers.map((offer) => offer.seller?.displayName),
  )

  return uniqueSellers.size
}
